import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { AssetTypeDetailViewTopBar } from "./TopBar"

export const assetTypeDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: AssetTypeDetailViewTopBar,
}
